import {
  ESCALATION_SETTINGS_REQUEST,
  ESCALATION_SETTINGS_FAILURE,
  FETCH_ESCALATION_SETTINGS_SUCCESS,
  CREATE_ESCALATION_SETTING_SUCCESS,
  UPDATE_ESCALATION_SETTING_SUCCESS,
  DELETE_ESCALATION_SETTING_SUCCESS,
} from "../action/types";

const initialState = {
  rules: [],
  loading: false,
  error: null,
  fetched: false,
};

const escalationSettingsReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case ESCALATION_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case ESCALATION_SETTINGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case FETCH_ESCALATION_SETTINGS_SUCCESS: {
      const rulesArray = Array.isArray(payload)
        ? payload
        : Array.isArray(payload?.data)
        ? payload.data
        : [];
      return {
        ...state,
        loading: false,
        rules: rulesArray.map((r) => ({ ...r, stage: r.type })),
        fetched: true,
      };
    }

    case CREATE_ESCALATION_SETTING_SUCCESS:
      return {
        ...state,
        loading: false,
        rules: [...state.rules, { ...payload, stage: payload.type }],
      };

    case UPDATE_ESCALATION_SETTING_SUCCESS:
      return {
        ...state,
        loading: false,
        rules: state.rules.map((r) =>
          r.id === payload.id ? { ...payload, stage: payload.type } : r
        ),
      };

    case DELETE_ESCALATION_SETTING_SUCCESS:
      return {
        ...state,
        loading: false,
        rules: state.rules.filter((r) => r.id !== payload),
      };

    default:
      return state;
  }
};

export default escalationSettingsReducer;
